import React from 'react';

/**
 * FilterChip — 가로 스크롤 필터 / 카테고리 chip.
 *
 * shared.css .filter-row .fp 변환.
 */

export interface FilterChipProps {
  label: string;
  active?: boolean;
  /** 우측 카운트 (예: " 12") */
  count?: number;
  /** 아이콘 (좌측) */
  icon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  /** 강조형 (오렌지 액센트) */
  emphasis?: boolean;
}

export const FilterChip: React.FC<FilterChipProps> = ({
  label,
  active = false,
  count,
  icon,
  onClick,
  className = '',
  emphasis = false,
}) => {
  const base = 'inline-flex shrink-0 items-center gap-1 rounded-full px-3.5 py-2 text-[12.5px] font-bold tracking-tight transition-colors';
  let theme = '';
  if (active) {
    theme = 'bg-ink text-white border border-ink';
  } else if (emphasis) {
    theme = 'bg-accent-50 text-accent-dark border border-accent-line';
  } else {
    theme = 'bg-ca-surface text-muted border border-ca-line';
  }
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`${base} ${theme} ${className}`}
    >
      {icon && <span className="inline-flex">{icon}</span>}
      <span>{label}</span>
      {typeof count === 'number' && (
        <span className={active ? 'text-white/70 font-medium ml-0.5' : 'text-mute2 font-medium ml-0.5'}>
          {count}
        </span>
      )}
    </button>
  );
};

/**
 * FilterChipRow — 가로 스크롤 컨테이너.
 */
export const FilterChipRow: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children, className = '',
}) => (
  <div
    className={`flex gap-1.5 overflow-x-auto border-b border-ca-line bg-frame px-3.5 py-2.5 scrollbar-none ${className}`}
    style={{ scrollbarWidth: 'none' }}
  >
    {children}
  </div>
);

export default FilterChip;
